export default {

    data: function() {

        return {

            model: {}

        }

    }

}